import * as React from 'react';

interface Props {
  children: any;
  styleName?: any;
}
export const ErrorForm = ({ children, styleName = '' }: Props) => {
  return <div className={`errorForm mediumText4 padding-t-4 padding-b-4 padding-l-8 ${styleName}`}>{children}</div>;
};
